import React, { useState, useEffect } from 'react';
import debounce from 'lodash.debounce';

/**
 * React hook that allows debouncing of any fast-changing
 *	state values. See https://usehooks.com/useDebounce/.
 *
 * @param {*}      value   The state value.
 * @param {Number} timeout The number of milliseconds to delay.
 *
 * @returns {*} The debounced state value.
 */
function useDebounce(value, timeout) {

	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {

		const debouncedUpdate = debounce(() => setDebouncedValue(value), timeout);

		debouncedUpdate();

		return debouncedUpdate.cancel;

	}, [value, timeout]);

	return debouncedValue;

}

export default useDebounce;
